import React from 'react';

interface SectionHeaderProps {
  id: string;
  title: string;
  eyebrow?: string | undefined;
  intro?: React.ReactNode | undefined;
  level?: 2 | 3;
}

/** Shared heading block: optional eyebrow label, title, and short intro. */
const SectionHeader: React.FC<SectionHeaderProps> = ({ id, title, eyebrow, intro, level = 2 }) => {
  const Heading = level === 2 ? 'h2' : 'h3';
  return (
    <header className="ui-section-header">
      {eyebrow && <p className="ui-section-header__eyebrow">{eyebrow}</p>}
      <Heading id={id} className="ui-section-header__title">
        {title}
      </Heading>
      {intro && <p className="ui-section-header__intro">{intro}</p>}
    </header>
  );
};

export default SectionHeader;
